import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const CompatibilityChecker = ({ motorcycles, onCheck }) => {
  const [selectedModel, setSelectedModel] = useState('');
  const [selectedYear, setSelectedYear] = useState('');

  const modelOptions = motorcycles?.map(m => ({
    value: m?.id,
    label: m?.name
  }));

  const yearOptions = selectedModel
    ? motorcycles?.find(m => m?.id === selectedModel)?.years?.map(y => ({
        value: y,
        label: y?.toString()
      })) || []
    : [];

  const handleCheck = () => {
    if (selectedModel && selectedYear) {
      onCheck({ model: selectedModel, year: selectedYear });
    }
  };

  return (
    <div className="bg-gradient-to-br from-primary/5 to-accent/5 rounded-lg p-4 md:p-6 border-2 border-primary/20">
      <div className="flex items-center space-x-3 mb-4">
        <div className="w-12 h-12 bg-primary rounded-lg flex items-center justify-center shadow-honda-glow">
          <Icon name="CheckCircle" size={24} color="white" />
        </div>
        <div>
          <h3 className="text-lg font-heading font-bold text-foreground">
            Cek Kompatibilitas
          </h3>
          <p className="text-sm text-muted-foreground">
            Pastikan part cocok dengan motor Anda
          </p>
        </div>
      </div>

      <div className="space-y-4">
        <Select
          label="Model Motor"
          placeholder="Pilih model motor"
          options={modelOptions}
          value={selectedModel}
          onChange={setSelectedModel}
          searchable
        />

        <Select
          label="Tahun Produksi"
          placeholder="Pilih tahun"
          options={yearOptions}
          value={selectedYear}
          onChange={setSelectedYear}
          disabled={!selectedModel}
        />

        <Button
          variant="default"
          size="lg"
          fullWidth
          iconName="Search"
          iconPosition="left"
          onClick={handleCheck}
          disabled={!selectedModel || !selectedYear}
        >
          Cek Kompatibilitas
        </Button>
      </div>

      <div className="mt-4 p-3 bg-card rounded-lg">
        <div className="flex items-start space-x-2">
          <Icon name="Info" size={16} color="var(--color-primary)" className="mt-0.5 flex-shrink-0" />
          <p className="text-xs text-muted-foreground">
            Sistem akan menampilkan part yang kompatibel dengan motor Anda. 
            Untuk konsultasi lebih lanjut, hubungi tim kami.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CompatibilityChecker;